module.exports = require("lodash/union");